export interface ReminderSettings {
    reminder_1_days: number | null;
    reminder_2_days: number | null;
    reminder_3_days: number | null;
}

/**
 * Calcule les jours de rappels selon la durée de campagne
 */
export function calculateReminderDays(campaignDuration: string): ReminderSettings {
    switch (campaignDuration) {
        case '3_days':
            return {
                reminder_1_days: 2,
                reminder_2_days: 3,
                reminder_3_days: null // Pas de 3e rappel pour 3 jours
            };

        case '5_days':
            return {
                reminder_1_days: 2,
                reminder_2_days: 3,
                reminder_3_days: 4
            };

        case '1_week':
            return {
                reminder_1_days: 2,
                reminder_2_days: 4,
                reminder_3_days: 6
            };

        case '2_weeks':
            return {
                reminder_1_days: 3,
                reminder_2_days: 7,
                reminder_3_days: 11
            };

        case '1_month':
            return {
                reminder_1_days: 7,
                reminder_2_days: 14,
                reminder_3_days: 21
            };

        default:
            // Valeurs par défaut (anciennes valeurs)
            return {
                reminder_1_days: 2,
                reminder_2_days: 5,
                reminder_3_days: 7
            };
    }
}

/**
 * Formate les jours de rappels pour l'affichage
 */
export function formatReminderDays(settings: ReminderSettings): Array<{
    label: string;
    days: number;
}> {
    const reminders = [];

    if (settings.reminder_1_days) {
        reminders.push({
            label: 'Premier rappel :',
            days: settings.reminder_1_days
        });
    }

    if (settings.reminder_2_days) {
        reminders.push({
            label: 'Deuxième rappel :',
            days: settings.reminder_2_days
        });
    }

    if (settings.reminder_3_days) {
        reminders.push({
            label: 'Troisième rappel :',
            days: settings.reminder_3_days
        });
    }

    return reminders;
}